module.exports = __webpack_public_path__ + "img/landpage.7139121d.png";